<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>
    <basic-table
      v-if="tariffPlans"
      :items="tariffPlans"
      :fields="tariffPlansFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <b-modal hide-footer :title="$t('Tariff plans detail')" ref="modalTariffPlans">
      <FormTariffPlans
      :isEdit="isEdit"
      :currentRowTariffPlans="selectedTarrifPlans"
      @hideTariffPlans="hideTariffPlans"/>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import FormTariffPlans from '../formTariffPlans'
export default {
  components: {
    FormTariffPlans
  },
  data () {
    return {
      tariffPlansFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Created on'), sortable: true},
        {key: 'whoCreate', label: this.$i18n.t('Created by'), sortable: true},
        {key: 'change_date', label: this.$i18n.t('Modified on'), sortable: true},
        {key: 'whoChange', label: this.$i18n.t('Modified by'), sortable: true},
        {key: 'balanceRollover', label: this.$i18n.t('Zero balance at the accounting period end'), sortable: true},
        {key: 'comments', label: this.$i18n.t('Comment'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      isEdit: false,
      selectedTarrifPlans: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    hideTariffPlans () {
      this.$refs.modalTariffPlans.hide()
    },
    showAdd () {
      this.isEdit = false
      this.$refs.modalTariffPlans.show()
    },
    editItem (item) {
      this.isEdit = true
      this.selectedTarrifPlans = item
      this.$refs.modalTariffPlans.show()
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Tariff plans"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Tariffing/DELETE_TARIFFS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TARIFFS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    tariffPlans () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TARIFFS']))
      for (let el of copy) {
        for (let elSysUsers of JSON.parse(JSON.stringify(this.$store.getters['Users/SYSTEM_USERS']))) {
          if (elSysUsers.user_id === el.who_create) {
            el.whoCreate = elSysUsers.login + ' (' + elSysUsers.user_id + ')'
          }
          if (elSysUsers.user_id === el.who_change) {
            el.whoChange = elSysUsers.login + ' (' + elSysUsers.user_id + ')'
          }
        }
        if (el.balance_rollover === 1) {
          el.balanceRollover = true
        } else {
          el.balanceRollover = false
        }
        if (el.change_date === 0) {
          el.change_date = this.$i18n.t('Not installed')
        } else {
          el.change_date = moment(Number(el.change_date) * 1000).format('DD-MM-YYYY hh:mm:ss')
        }
        if (el.create_date === 0) {
          el.create_date = this.$i18n.t('Not installed')
        } else {
          el.create_date = moment(Number(el.create_date) * 1000).format('DD-MM-YYYY hh:mm:ss')
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_TARIFFS')
    this.$store.dispatch('Users/GET_SYSTEM_USERS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/tariffPlans/main.vue